import React, {Component} from 'react';
import codenine from "assets/img/code9.png";



class DocumentationFour extends Component {
    render() {
        return (
            <div>
                <div>
                    <div className="p-20">
                        <br />
                        <p>API logs for debugging purpose</p>
                        <br/>
                        <div className="clearfix"></div>
                        <img src={codenine} alt={codenine} className="mSpaceLogo" width={'98%'}/>

                        <br/>
                        <div className="clearfix"></div>
                        <blockquote>
                            <small>Refresh - It will fetch latest API logs and shows below.</small>
                            <small>Download - It will download </small>
                        </blockquote>
                    </div>
                </div>

            </div>
        );
    }
}

export default DocumentationFour;